import initialState from '../store/initial-state'
import {
  LOGIN_USER,
  LOGIN_USER_SUCCESS,
  LOGIN_USER_FAILURE,
  REFRESH_TOKEN,
  REFRESH_TOKEN_SUCCESS,
  REFRESH_TOKEN_FAILURE,
  LOGOUT_USER,
  RECOVERY_PASSWORD,
  RECOVERY_PASSWORD_SUCCESS,
  RECOVERY_PASSWORD_FAILURE,
  RESTART_RECOVERY,
  USER_CHANGE_PASSWORD,
  USER_CHANGE_PASSWORD_SUCCESS,
  USER_CHANGE_PASSWORD_FAILURE,
  SET_USER_CLIENT_ROLE,
  SET_USER_CLIENT_ROLE_SUCCESS,
  SET_USER_CLIENT_ROLE_FAILURE,
  USER_MODAL_NEWS,
  USER_FORCE_PASSWORD_CHANGE,
  USER_SHOW_NOTIFICATION_ANIMATION,
  CLEAN_ERROR
} from '../constants/login-types'
import { AVATAR_CONFIG, AVATAR_CONFIG_SUCCESS, AVATAR_CONFIG_FAILURE } from '../constants/avatar-types';
import { COLOR_CHANGE, COLOR_CHANGE_FAILURE, COLOR_CHANGE_SUCCESS, COLOR_CHANGE_FORCE } from '../constants/color-types';

export default (state = initialState.authUser, action) => {
  switch (action.type) {

    case LOGIN_USER:
      return {
        ...state,
        isFetching: true,
        user: null,
        token: null,
        error: null
      }

    case LOGIN_USER_SUCCESS:
      return {
        ...state,
        isFetching: false,
        user: action.payload.user,
        exp: action.payload.exp,
        token: action.payload.token,
        error: null
      }

    case LOGIN_USER_FAILURE:
      return {
        ...state,
        isFetching: false,
        user: null,
        token: null,
        error: action.payload
      }

    case LOGOUT_USER:
      return {
        ...state,
        isFetching: false,
        user: null,
        token: null,
        error: null
      }


    case REFRESH_TOKEN:
      return {
        ...state,
        error: null
      }


    case REFRESH_TOKEN_SUCCESS:
      return {
        ...state,
        error: null
      }

    case REFRESH_TOKEN_FAILURE:
      return {
        ...state,
        error: action.payload
      }

    case RECOVERY_PASSWORD:
      return {
        ...state,
        isFetching: true,
        user: null,
        token: null,
        error: null,
        passRecovered: false
      }

    case RECOVERY_PASSWORD_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        passRecovered: true
      }

    case RECOVERY_PASSWORD_FAILURE:
      return {
        ...state,
        isFetching: false,
        user: null,
        token: null,
        passRecovered: false,
        error: action.payload
      }

    case RESTART_RECOVERY:
      return {
        ...state,
        passRecovered: false,
      }

    case USER_CHANGE_PASSWORD:
      return {
        ...state,
        changePasswordIsFetching: true,
        changePassword: null
      }

    case USER_CHANGE_PASSWORD_SUCCESS:
      return {
        ...state,
        changePasswordIsFetching: false,
        changePassword: 'success',
        user: {
          ...state.user,
          name: action.payload
        }
      }

    case USER_CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        changePasswordIsFetching: false,
        changePassword: 'error'
      }

    case AVATAR_CONFIG:
      return {
        ...state,
        user: {
          ...state.user,
          changeAvatarIsFetching: true
        }
      }

    case AVATAR_CONFIG_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          avatar: action.payload,
          changeAvatarIsFetching: false,
          error: ''
        }
      }

    case AVATAR_CONFIG_FAILURE:
      return {
        ...state,
        user: {
          ...state.user,
          changeAvatarIsFetching: false,
          error: action.payload,
        }
      }

    case COLOR_CHANGE:
      return {
        ...state,
        isFetching: true,
      }

    case COLOR_CHANGE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        user: {
          ...state.user,
          color: action.payload
        }
      }

    case COLOR_CHANGE_FORCE:
      return {
        ...state,
        user: {
          ...state.user,
          color: action.payload
        }
      }

    case COLOR_CHANGE_FAILURE:
      return {
        ...state,
        isFetching: false,
        user: {
          ...state.user,
          error: '#2E97CF'
        }
      }

    case SET_USER_CLIENT_ROLE:
      return {
        ...state,
        user: {
          ...state.user,
          clientRole: ''
        }
      }

    case SET_USER_CLIENT_ROLE_SUCCESS:
      return {
        ...state,
        user: {
          ...state.user,
          clientRole: action.clientRole
        }
      }

    case SET_USER_CLIENT_ROLE_FAILURE:
      return {
        ...state,
        user: {
          ...state.user,
          clientRole: ''
        }
      }

    case USER_MODAL_NEWS:
      return {
        ...state,
        user: {
          ...state.user,
          modalNews: action.payload
        }
      }

    case USER_FORCE_PASSWORD_CHANGE:
      return {
        ...state,
        user: {
          ...state.user,
          forcePasswordChange: action.payload
        }
      }

    case USER_SHOW_NOTIFICATION_ANIMATION:
      return {
        ...state,
        user: {
          ...state.user,
          showNotificationAnimation: action.payload
        }
      }
    case CLEAN_ERROR:
      return {
        ...state,
        error: null
      }

    default: return { ...state }
  }
}